<template>
  <v-container fluid>
    <template>
      <v-container>
        <v-row class="ma-1 pa-1">
          <v-col>
            <template>
              <v-row class="ma-1 pa-1">
                <v-dialog
                    v-model="dialog"
                    fullscreen
                    hide-overlay
                    transition="dialog-bottom-transition"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                        color="orange"
                        dark
                        v-bind="attrs"
                        v-on="on"
                    >
                      Добавить
                    </v-btn>
                  </template>
                  <v-card>
                    <v-toolbar
                        dark
                        color="primary"
                    >
                      <v-btn
                          icon
                          dark
                          @click="dialog = false"
                      >
                        <v-icon>mdi-close</v-icon>
                      </v-btn>
                      <v-toolbar-title>Форма добавления</v-toolbar-title>
                    </v-toolbar>
                    <v-card-text>
                      <v-row class="ma-2 pa-2">
                        <v-autocomplete
                            v-model="objID"
                            :items="objs"
                            item-text="NAME"
                            item-value="ID"
                            label="Выберите объект"
                            @input="getWorkType"
                        >
                        </v-autocomplete>
                      </v-row>
                      <template v-if="saveItems.length > 0">
                        <template v-for="(item, index) in saveItems">
                          <v-row :key="index" class="ma-2 pa-2">
                            <v-autocomplete
                                v-model="item.name"
                                :items="workTypes"
                                label="Выберите вид работ"
                            >
                            </v-autocomplete>
                          </v-row>
                          <template v-for="tech in item.techs">
                            <v-autocomplete
                                :key="item.name+ '/' + tech.id + '/'+'tech'"
                                class="ma-2 pa-2"
                                v-model="tech.techID"
                                label="Наименование техники"
                                :items="tecnics"
                                item-text="NAME"
                                item-value="ID"
                                required
                            ></v-autocomplete>
                            <v-autocomplete
                                :key="item.name+ '/' + tech.id + '/'+ 'material'"
                                class="ma-2 pa-2"
                                v-model="tech.materialID"
                                label="Наименование материала"
                                :items="materials"
                                item-text="NAME"
                                item-value="ID"
                                required
                            ></v-autocomplete>
                            <v-select
                                :key="item.name+ '/' + tech.id + '/'+ 'typeHours'"
                                class="ma-2 pa-2"
                                v-model="tech.typeHours"
                                :items="typeQuantity"
                                item-text="NAME"
                                item-value="ID"
                                label="Единица измерения"
                                required
                            ></v-select>
                            <v-text-field
                                :key="item.name+ '/' + tech.id + '/'+ 'quntity'"
                                class="ma-2 pa-2"
                                v-model="tech.hoursPlan"
                                label="ПЛАН Количество"
                                required
                            ></v-text-field>
                            <v-divider
                                class="mb-5"
                                :key="item.name+ '/' + tech.id + '/'+ 'divider'"
                                inset
                            ></v-divider>
                          </template>
                          <v-btn :key="index + 'btn'" @click="addTechRow(item)">техника/материал</v-btn>
                          <v-divider
                              class="ma-5"
                              :key="index + 'divider'"
                              inset
                          ></v-divider>
                        </template>
                      </template>
                      <v-btn @click="addRowTypeWork">Добавить вид работ</v-btn>
                    </v-card-text>
                    <v-toolbar
                        dark
                        color="primary"
                    >
                      <v-toolbar-items>
                        <v-btn
                            :disabled="disable"
                            dark
                            text
                            @click="saveRow"
                        >
                          Сохранить
                        </v-btn>
                      </v-toolbar-items>
                    </v-toolbar>
                  </v-card>
                </v-dialog>
              </v-row>
            </template>
          </v-col>
        </v-row>
      </v-container>
    </template>
    <v-row>
      <v-col>
        <v-data-table
            :headers="headers"
            :items="planItems"
            :items-per-page="10"
        >

          <template v-slot:item.actions="{ item }">
            <v-icon
                small
                class="mr-3"
                @click="editItem(item)"
            >
              mdi-pencil
            </v-icon>
            <v-icon
                small
                class="mr-2"
                @click="deleteItem(item)"
            >
              mdi-delete
            </v-icon>
            <v-row class="ma-1 pa-1">
              <v-dialog
                  v-model="item.editDialog"
                  fullscreen
                  hide-overlay
                  transition="dialog-bottom-transition"
              >
                <v-card>
                  <v-toolbar
                      dark
                      color="primary"
                  >
                    <v-btn
                        icon
                        dark
                        @click="item.editDialog = false"
                    >
                      <v-icon>mdi-close</v-icon>
                    </v-btn>
                    <v-toolbar-title>Форма редактирования</v-toolbar-title>
                  </v-toolbar>
                  <v-card-text>
                    <v-autocomplete
                        v-model="item.objID"
                        :items="objs"
                        item-text="NAME"
                        item-value="ID"
                        label="Выберите объект"
                        @input="getWorkType"
                    >
                    </v-autocomplete>
                    <v-autocomplete
                        v-model="item.typeWork"
                        :items="workTypes"
                        label="Выберите вид работ"
                    >
                    </v-autocomplete>
                    <v-autocomplete
                        v-model="item.techID"
                        label="Наименование техники"
                        :items="tecnics"
                        item-text="NAME"
                        item-value="ID"
                        required
                    ></v-autocomplete>
                    <v-autocomplete
                        v-model="item.techID"
                        label="Наименование материала"
                        :items="materials"
                        item-text="NAME"
                        item-value="ID"
                        required
                    ></v-autocomplete>
                    <v-select
                        v-model="item.typeQuantityID"
                        :items="typeQuantity"
                        item-text="NAME"
                        item-value="ID"
                        label="Единица измерения"
                        required
                    ></v-select>
                    <v-text-field
                        v-model="item.quantity"
                        label="ПЛАН Количество"
                        required
                    ></v-text-field>
                  </v-card-text>
                  <v-toolbar
                      dark
                      color="primary"
                  >
                    <v-toolbar-items>
                      <v-btn
                          :disabled="disable"
                          dark
                          text
                          @click="saveRow(false, item)"
                      >
                        Сохранить
                      </v-btn>
                    </v-toolbar-items>
                  </v-toolbar>
                </v-card>
              </v-dialog>
            </v-row>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
    <template>

    </template>
  </v-container>
</template>

<script>
//import exeljs from 'exceljs'
//import fileWrite from 'file-saver'
import axios from "axios";

export default {
  name: "planTech",
  data() {
    return {
      disable: false,
      headers: [
        {text: 'Действие', value: 'actions', sortable: false},
        {text: 'Объект', value: 'obj'},
        {text: 'Вид работ', value: 'typeWork'},
        {text: 'Техника/материал', value: 'tech'},
        {text: 'Кол-во', value: 'quantity'},
        {text: 'Потрачено', value: 'spent'},
        {text: 'Остаток', value: 'quantityLow'},
        {text: 'Ед. измерения', value: 'typeQuantity'},
      ],
      typeQuantity: [{ID: 1509, NAME: 'м3'}, {ID: 1511, NAME: 'м2'}, {ID: 1513, NAME: 'шт'},
        {ID: 1515, NAME: 'мп'}, {ID: 1517, NAME: 'сутки'}, {ID: 1519, NAME: 'маш/час'}, {ID: 1521, NAME: 'смена'}],
      dialog: false,
      objID: '',
      saveItems: [],
      planItems: [],
      workTypes: [],
      tecnics: [],
      materials: [],
      objs: [],
      url: 'https://citystroi.bitrix24.ru/rest/73/gjdt5g3y10jxw3r9/'
    }
  },
  methods: {
    editItem(item) {
      item.editDialog = !item.editDialog
      this.getWorkType(item.objID)
      console.log({item})
    },
    async deleteItem(item) {
      try {
        const index = this.planItems.findIndex((e) => e.id === item.id)
        this.planItems.splice(index, 1);
        const params = {
          'IBLOCK_TYPE_ID': 'lists',
          'IBLOCK_ID': '145',
          'ELEMENT_ID': item.id
        }
        await axios.post(this.url + 'lists.element.delete', params)
      } catch (e) {
        console.log(e)
      }
    },
    getWorkType(elem = '') {
      let objID = ''
      if (elem) objID = elem
      else objID = this.objID
      this.workTypes = []
      const obj = this.objs.filter(e => e.ID == objID)[0]
      const workType = (obj.PROPERTY_1353) ? Object.values(obj.PROPERTY_1353)[0] : ''
      this.workTypes = workType.replace(/\r\n|_/gi, '').split(';')
    },
    addTechRow(item) {
      console.log({item})
      item.techs.push({
        id: item.techs.length + 1,
        typeID: '',
        techID: '',
        materialID: '',
        hoursPlan: '',
        typeHours: ''
      })
    },
    addRowTypeWork() {
      this.saveItems.push({
        name: '',
        techs: [{
          id: 1,
          typeID: '',
          techID: '',
          materialID: '',
          hoursPlan: '',
          typeHours: ''
        }]
      });
    },
    async saveRow(newItem = true, item = null) {
      try {
        if (!newItem) {
          console.log({item})
          const params = {
            'IBLOCK_TYPE_ID': 'lists',
            'IBLOCK_ID': '145',
            'ELEMENT_ID': item.id,
            'FIELDS': {
              'NAME': 'План(app)',
              'PROPERTY_1347': item.objID,
              'PROPERTY_1361': item.typeWork,
              'PROPERTY_1363': item.quantity,
              'PROPERTY_1343': item.typeQuantityID,
              'PROPERTY_1345': item.quantityLow,
              'PROPERTY_1339': '',
              'PROPERTY_1341': ''
            }
          }
          console.log({params})
          if (item.typeTech === 'tech') params.FIELDS.PROPERTY_1339 = item.techID
          else params.FIELDS.PROPERTY_1341 = item.techID
          await axios.post(this.url + 'lists.element.update', params)
          item.editDialog = !item.editDialog
        } else {
          this.disable = true
          const batchParams = {
            'halt': 0,
            'cmd': {}
          }

          for (const typeWork of this.saveItems) {
            for (const itemIndex in typeWork.techs) {
              batchParams.cmd[itemIndex] = `lists.element.add?IBLOCK_TYPE_ID=lists&IBLOCK_ID=145&ELEMENT_CODE=${typeWork.name + '/' + itemIndex + '/' + new Date()}&FIELDS[NAME]=План(app)&FIELDS[PROPERTY_1347]=${this.objID}&FIELDS[PROPERTY_1361]=${typeWork.name}&FIELDS[PROPERTY_1345]=${typeWork.techs[itemIndex].hoursPlan}&FIELDS[PROPERTY_1363]=${typeWork.techs[itemIndex].hoursPlan}&FIELDS[PROPERTY_1343]=${typeWork.techs[itemIndex].typeHours}&`
              if (typeWork.techs[itemIndex].techID) {
                batchParams.cmd[itemIndex] += `FIELDS[PROPERTY_1339]=${typeWork.techs[itemIndex].techID}`
              } else {
                batchParams.cmd[itemIndex] += `FIELDS[PROPERTY_1341]=${typeWork.techs[itemIndex].materialID}`
              }
              if (itemIndex % 50 == 0 || itemIndex == Number(typeWork.techs.length) - 1) {
                console.log(batchParams, 'batchParams')
                const batchResult = await axios.post(this.url + 'batch', batchParams)
                console.log(batchResult.data.result.result, 'batchRes')
                batchParams.cmd = {}
              }
            }
          }
        }

        this.saveItems = []
        await this.getPlanData();
        this.disable = false
      } catch (e) {
        console.log(e)
      }
    },
    async getPlanData() {
      try {
        this.planItems = []
        const paramsPlan = {
          'IBLOCK_TYPE_ID': 'lists',
          'IBLOCK_ID': '145',
        }
        const planData = await axios.post(this.url + 'lists.element.get', paramsPlan)
        for (const item of planData.data.result) {
          console.log({item})
          const type = (item.PROPERTY_1343) ? this.typeQuantity.filter((e) => e.ID == Object.values(item.PROPERTY_1343)[0]) : ''
          console.log({type})
          const pushItem = {
            id: item.ID,
            obj: (item.PROPERTY_1347) ? this.objs.filter((e) => {
              return e['ID'] == Object.values(item.PROPERTY_1347)[0]
            })[0].NAME : '',
            objID: (item.PROPERTY_1347) ? this.objs.filter((e) => {
              return e['ID'] == Object.values(item.PROPERTY_1347)[0]
            })[0].ID : '',
            typeWork: (item.PROPERTY_1361) ? Object.values(item.PROPERTY_1361)[0] : '',
            editDialog: false,
            tech: '',//Object.values(item.PROPERTY_1339)||1341,
            typeTech: '',
            quantity: (item.PROPERTY_1363) ? Object.values(item.PROPERTY_1363)[0] : '',
            spent: Number(Object.values(item.PROPERTY_1363)[0]) - Number(Object.values(item.PROPERTY_1345)[0]),
            quantityLow: (item.PROPERTY_1345) ? Object.values(item.PROPERTY_1345)[0] : '',
            typeQuantity: (item.PROPERTY_1343) ? this.typeQuantity.filter((e) => e.ID == Object.values(item.PROPERTY_1343)[0])[0].NAME : '',
            typeQuantityID: (item.PROPERTY_1343) ? this.typeQuantity.filter((e) => e.ID == Object.values(item.PROPERTY_1343)[0])[0].ID : '',
          }
          let technicTITLE = ''
          let technicID = ''
          if (item.PROPERTY_1339) {
            if (Object.values(item.PROPERTY_1339)[0] != '0') {
              technicTITLE = this.tecnics.filter((e) => {
                return e['ID'] == Object.values(item.PROPERTY_1339)[0]
              })[0].NAME
              technicID = this.tecnics.filter((e) => {
                return e['ID'] == Object.values(item.PROPERTY_1339)[0]
              })[0].ID
              pushItem.typeTech = 'tech'
            } else {
              technicTITLE = this.materials.filter((e) => {
                return e['ID'] == Object.values(item.PROPERTY_1341)[0]
              })[0].NAME
              technicID = this.materials.filter((e) => {
                return e['ID'] == Object.values(item.PROPERTY_1339)[0]
              })[0].ID
              pushItem.typeTech = 'material'
            }
          } else {
            technicTITLE = (item.PROPERTY_1341) ? this.materials.filter((e) => {
              return e['ID'] == Object.values(item.PROPERTY_1341)[0]
            })[0].NAME : ''
            technicID = (item.PROPERTY_1341) ? this.materials.filter((e) => {
              return e['ID'] == Object.values(item.PROPERTY_1341)[0]
            })[0].ID : ''
            pushItem.typeTech = 'material'
          }
          pushItem.tech = technicTITLE
          pushItem.techID = technicID
          console.log(pushItem)

          this.planItems.push(pushItem)
        }

        console.log(planData)
      } catch (e) {
        console.log(e)
      }
    },
    async getTechnics() {
      try {
        console.log('tech')
        this.tecnics = []
        const params = {
          IBLOCK_TYPE_ID: 'lists',
          IBLOCK_ID: '103',
        }
        const method = 'lists.element.get'
        let i = 1
        let next = 0
        while (i > 0) {
          params.start = next
          const tecnicsData = await axios.post(this.url + method, params)
          next = tecnicsData.data.next
          for (const elem of tecnicsData.data.result) {
            this.tecnics.push(elem)
          }
          if (!next) {
            i = 0
          }
        }
        console.log(this.tecnics)
        this.tecnics.sort((a, b) => {
          if (a['NAME'] < b['NAME']) {
            return -1;
          }
          if (a['NAME'] > b['NAME']) {
            return 1;
          }
          // a должно быть равным b
          return 0;
        })
      } catch (e) {
        console.log(e)
      }
    },
    async getMaterials() {
      try {
        console.log('materials')
        this.materials = []
        const params = {
          IBLOCK_TYPE_ID: 'lists',
          IBLOCK_ID: '107',
        }
        const method = 'lists.element.get'
        let i = 1
        let next = 0
        while (i > 0) {
          params.start = next
          const materialData = await axios.post(this.url + method, params)
          next = materialData.data.next
          for (const elem of materialData.data.result) {
            this.materials.push(elem)
          }
          if (!next) {
            i = 0
          }
        }
        console.log(this.materials)
        this.materials.sort((a, b) => {
          if (a['NAME'] < b['NAME']) {
            return -1;
          }
          if (a['NAME'] > b['NAME']) {
            return 1;
          }
          // a должно быть равным b
          return 0;
        })
      } catch (e) {
        console.log(e)
      }
    },
    async getObj() {
      try {
        this.objs = []
        const params = {
          IBLOCK_TYPE_ID: 'lists',
          IBLOCK_ID: '97',
        }
        const method = 'lists.element.get'
        let i = 1
        let next = 0
        while (i > 0) {
          params.start = next
          const objData = await axios.post(this.url + method, params)
          next = objData.data.next
          this.objs.push(...objData.data.result)
          if (!next) {
            i = 0
          }
        }
        //console.log(this.obj)
        this.objs.sort((a, b) => {
          if (a['NAME'] < b['NAME']) {
            return -1;
          }
          if (a['NAME'] > b['NAME']) {
            return 1;
          }
          // a должно быть равным b
          return 0;
        })
      } catch (e) {
        console.log(e)
      }
    },

  },
  async mounted() {
    await this.getObj();
    await this.getMaterials();
    await this.getTechnics();
    await this.getPlanData();
  }
}
</script>

<style scoped>

</style>